import { useEffect, useRef, useState } from "react"
import * as mpPose from '@mediapipe/pose'
import * as poseDetection from '@tensorflow-models/pose-detection';
import * as tf from '@tensorflow/tfjs-core';
import '@tensorflow/tfjs-backend-webgl';
import Webcam from "react-webcam"
import { drawMovenetLandmarks, liveDrawMovenetLandmarks } from "../util/LandmarksUtils";
const blazepose_configs = {
    model: poseDetection.SupportedModels.BlazePose,
    estimation_configs:{
        runtime:'mediapipe',
        flipHorizontal:false,
        enableSmoothing:true,
    },
    config:{
        runtime:'mediapipe',
        modelType:'full',
        enableSmoothing:true,
        solutionPath : 'https://cdn.jsdelivr.net/npm/@mediapipe/pose'
    },
}
let detector
const MovenetLive = () =>{
    const [detectorType,setDetectorType] = useState('blazepose')
    const [detectorConfigs,setDetectorConfigs] = useState({})
    const webcamRef = useRef(null)
    const canvasRef= useRef(null)

    const detectorCreate = async(all_config)=>{
        detector = await poseDetection.createDetector(
            all_config.model,
            all_config.config
        )
        console.log(detector)
    }

    const startDetectHandler = async() =>{
        try{
            setInterval(async () => {
                let canvas_ctx = canvasRef.current.getContext('2d')
                let poses = await detector.estimatePoses(webcamRef.current.video,detectorConfigs.estimation_configs).then((poses)=>{
                    canvas_ctx.drawImage(webcamRef.current.video, 0, 0, 640, 480);
                    canvas_ctx.clearRect(0,0,640,480)
                    liveDrawMovenetLandmarks(canvasRef.current.getContext('2d'),poses[0].keypoints,false,640,480)
                })
            }, 33);
        }
        catch(e){
            console.log(e)
        }
    }

    useEffect(()=>{
        detectorCreate(blazepose_configs)
        
    },[])

    return(
        <>
            <Webcam
                height={480}
                width={640}
                ref={webcamRef}
                style={{
                    position: 'absolute'
                }}
            ></Webcam>
            <canvas
                ref={canvasRef}
                height={480}
                width={640}
                style={{
                    position: 'absolute',
                }}
            ></canvas>
            <br />
            <button style={{marginTop:'500px'}}  onClick={startDetectHandler}>Start Cam</button>
        </>
    )
}

export default MovenetLive
